<template>
  <main>
    <div id="expert-users-wrap">
      <div id="expert-users-nav">
        <router-link to="/expert">Back to expert page</router-link>
      </div>
      <div id="expert-users-head">
        <h1 v-if="isDesktop">Meet Our Experts</h1>
        <div v-if="isDesktop" id="expert-users-categories">
          <swiper ref="swiper" :options="swiperOption">
            <template v-for="(role, index) in roles">
              <swiper-slide :key="'role' + index" :class="{ all: role.slug === 'all', ['role-' + role.slug]: true }">
                <a href="#" :class="{ selected: checkCurrentRole(role.slug) }" @click.prevent="chooseRole(role.slug)">
                  <span><img :src="role.image" height="20" width="20" /></span> {{ role.slug | expertRoleLabel
                  }}<template v-if="isDesktop && role.slug === 'all'"> ({{ expertRoleCount }})</template>
                </a>
              </swiper-slide>
            </template>
            <swiper-slide>
              <div class="dummy"></div>
            </swiper-slide>
          </swiper>
          <div class="button-prev"></div>
          <div class="button-next"></div>
        </div>
        <ul v-else id="expert-users-categories">
          <li v-for="(role, index) in roles" :key="'role-' + index">
            <a
              href="#"
              :class="{ selected: checkCurrentRole(role.slug), all: role.slug === 'all', ['role-' + role.slug]: true }"
              @click.prevent="chooseRole(role.slug)"
              ><span><img :src="role.image" height="20" width="20" /></span> {{ role.name }}</a
            >
          </li>
        </ul>
        <div id="expert-users-search">
          <input
            v-model="keyword"
            type="text"
            placeholder="Search expert"
            :class="{ filled: keyword }"
            @keyup="search($event)"
          />
          <span class="basic-icon--uniform close-grey-icon" @click="resetKeyword"></span>
        </div>
      </div>
      <ul v-if="experts.length && !loading" id="expert-users-list">
        <li v-for="(expert, index) in experts" :key="'expert-' + index" class="experts">
          <a :href="userLink(expert)" target="_blank" rel="noopener">
            <div>
              <img :src="expertImage(expert.image)" :alt="expert.name" @error="imageErrorHandler" />
            </div>
            <p>{{ expert.name }}</p>
            <span v-if="expertRole(expert.expert_role)" class="label">{{ expert.expert_role | expertRoleLabel }}</span>
          </a>
        </li>
      </ul>
      <div v-else-if="!experts.length && !loading" id="expert-no-users">
        <div>
          <img src="/assets/img/default-avatar.png" />
        </div>
        <p>Expert user not found</p>
      </div>
      <div v-if="loading" id="expert-users-loading">
        <GLoaderSpin :text="'Loading experts...'" />
      </div>
      <infinite-loading v-if="experts.length >= limit" @infinite="infiniteHandler">
        <div slot="no-more"></div>
        <div slot="no-results"></div>
        <div id="expert-users-infinite-loading" slot="spinner">
          <GLoaderSpin text="Loading experts..." />
        </div>
      </infinite-loading>
    </div>
  </main>
</template>

<script>
const Config = require('~/config/default.env').default;

import debounce from 'lodash.debounce';
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import 'swiper/dist/css/swiper.css';

export default {
  name: 'ExpertUsers',
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      keyword: '',
      experts: [],
      skip: 0,
      limit: 5,
      loading: true,
      infiniteLoading: false,
      roles: [
        {
          name: 'Semua',
          slug: 'all',
        },
      ],
      currentRole: 'all',
      expertRoleCount: 0,
      swiperOption: {
        slidesPerView: 'auto',
        spaceBetween: 8,
        navigation: {
          nextEl: '.button-next',
          prevEl: '.button-prev',
        },
        freeMode: true,
      },
    };
  },
  computed: {
    isDesktop() {
      return this.$store.state.screen.isDesktop;
    },
    keywordValid() {
      return this.keyword && this.keyword.trim().length > 3 ? true : false;
    },
    searchKeyword() {
      return {
        $or: [
          { name: { $regex: this.keyword, $options: 'i' } },
          { user_name: { $regex: this.keyword, $options: 'i' } },
        ],
      };
    },
    swiper() {
      if (this.isDesktop) {
        return this.$refs.swiper.swiper;
      } else {
        return null;
      }
    },
  },
  mounted() {
    this.getAllExperts('', false);
    this.fetchExpertRole();
    this.fetchExpertRoleCount();
  },
  created() {
    this.setPageTitle();
  },
  methods: {
    userLink(user) {
      return `${this.$store.state.SOCO_WEB_URL}/${user.user_name}`;
    },
    infiniteHandler($state) {
      this.infiniteLoading = true;
      this.getAllExperts($state, true);
    },
    resetParam() {
      this.skip = 0;
    },
    search: debounce(function (e) {
      if ((this.keyword && this.keyword.trim().length >= 3) || !this.keyword) {
        this.getAllExperts();
      }
    }, 500),
    chooseRole(role) {
      this.currentRole = role;
      // this.keyword = '';
      this.resetParam();
      this.getAllExperts('', false);
    },
    checkCurrentRole(role) {
      return this.currentRole === role;
    },
    setPageTitle() {
      this.$store.commit('setPageInfo', {
        title: 'Meet Our Experts',
      });
    },
    resetKeyword() {
      this.resetParam();
      if (this.keyword.length >= 3) {
        this.keyword = '';
        this.getAllExperts('', false);
      }
      this.keyword = '';
    },
    expertRole(role) {
      if (role) {
        const formattedRole = role.split('_').join(' ');
        return formattedRole;
      }
      return '';
    },
    expertImage(src) {
      if (src) {
        return this.$options.filters.imageCdn({
          config: 'w=80',
          image: src,
        });
      } else {
        return '/assets/img/default-avatar.png';
      }
    },
    imageErrorHandler(e) {
      e.target.src = '/assets/img/default-avatar.png';
    },
    getAllExperts($state, add) {
      if (!add) {
        this.loading = true;
        this.experts = [];
        this.resetParam();
      }
      const params = {
        skip: this.skip,
        limit: this.limit,
        ...(this.currentRole !== 'all'
          ? {
              filter: {
                expert_role: this.currentRole,
                ...(this.keywordValid ? this.searchKeyword : {}),
              },
            }
          : {}),
        ...(this.currentRole === 'all' && this.keywordValid
          ? {
              filter: this.searchKeyword,
            }
          : {}),
      };
      this.$MS_SOCO_PUBLIC_API_URL
        .get(`/expert-users`, { params })
        .then((res) => {
          if (res.data && res.data.data && res.data.data.length) {
            if (add) {
              this.experts = this.experts.concat(res.data.data);
            } else {
              this.experts = res.data.data;
            }
            if (res.data.data.length === this.limit) {
              this.skip = this.skip + this.limit;
              $state.loaded();
            } else {
              $state.complete();
            }
          }
          if (res.data && res.data.data && !res.data.data.length) {
            $state.complete();
          }
          this.loading = false;
          this.infiniteLoading = false;
        })
        .catch((err) => {
          this.loading = false;
          this.infiniteLoading = false;
        });
    },
    async fetchExpertRole() {
      return new Promise((resolve, reject) => {
        try {
          resolve(axios.get(`${Config.MS_SOCO_PUBLIC_API_URL}/expert-users/roles`));
        } catch (error) {
          reject(error);
        }
      }).then(({ data }) => {
        const roles = data.data || {};
        this.roles = [...this.roles, ...roles];
      });
    },
    async fetchExpertRoleCount() {
      return new Promise((resolve, reject) => {
        try {
          const filter = this.currentRole === 'all' ? undefined : { expert_role: this.currentRole };
          resolve(
            axios.get(`${Config.MS_SOCO_PUBLIC_API_URL}/expert-users/count`, {
              params: { filter },
            })
          );
        } catch (error) {
          reject(error);
        }
      }).then(({ data: count }) => {
        this.expertRoleCount = count.data;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import './src/assets/sass/_mixin-revamp.scss';
#expert-users-loading {
  padding: 12px 0 60px;
}
#expert-users-infinite-loading {
  margin-top: 0;
  padding: 12px 0 60px;
}
#expert-users-categories {
  padding: 16px 16px 16px 0;
  margin: 0;
  display: flex;
  overflow-y: auto;
  &::-webkit-scrollbar {
    display: none;
  }
  li {
    margin: 0 0 0 8px;
    display: block;
    list-style-type: none;
  }
  li:first-child {
    margin: 0 0 0 16px;
  }
  a {
    display: flex;
    padding: 5px 11px;
    border: 1px solid #f1f1f1;
    border-radius: 20px;
    background: #fff;
    font: normal 12px/14px $lato-regular;
    border-color: #f1f1f1;
    align-items: center;
    white-space: nowrap;
  }
  a.selected {
    background: #f384a7;
    color: #fff;
    border-color: #f384a7;
  }
  span {
    display: flex;
    width: 20px;
    height: 20px;
    border-radius: 10px;
    margin: 0 8px 0 0;
    background-color: #fedfe2;
    align-items: center;
    justify-content: center;
  }
  a.all span,
  .all span {
    opacity: 0;
    margin: 0;
    width: 0;
  }
  // a.dermatologist:before, a.dermatologist span {
  //   background-image: url('/assets/img/expert-review/expert-category-dermatologist.svg');
  // }
  &:after {
    content: '';
    display: block;
    width: 8px;
    height: 32px;
  }
}
#expert-users-search {
  display: flex;
  margin: 0 16px 16px;
  position: relative;
  &:before {
    display: block;
    width: 24px;
    height: 24px;
    margin: 0 16px 0 0;
    content: '';
    background: transparent url('/assets/img/icons/search.svg') no-repeat center;
    position: absolute;
    left: 8px;
    top: 8px;
  }
  span {
    position: absolute;
    right: 8px;
    top: 8px;
    display: block;
    width: 24px;
    height: 24px;
    cursor: pointer;
  }
  span:before {
    background-size: 16px;
    width: 24px;
    height: 24px;
  }
  input {
    width: 100%;
    font: normal 14px/22px $lato-regular;
    color: #8c8582;
    border: 0;
    background: #f8f8f8;
    border: 1px solid #f8f8f8;
    padding: 8px 48px;
    border-radius: 4px;
  }
  input:placeholder-shown + span {
    display: none;
  }
  input:focus {
    outline: 0;
    background: #fff;
    border-color: #f1f1f1;
    color: #231f20;
  }
  input.filled {
    background: #fff;
    color: #231f20;
  }
}
#expert-users-list {
  padding: 0 10.5px 0;
  display: flex;
  flex-wrap: wrap;
  margin: 0;
  text-align: center;
  li {
    display: block;
    width: calc((100% - 33px) / 3);
    list-style-type: none;
    padding: 16px 0;
    margin: 0 calc(11px / 2) 16px;
    border: 1px solid #e5e5e5;
    border-radius: 4px;
  }
  div {
    background: linear-gradient(90deg, #231f20 0%, #d8d8d8 78.43%, #231f20 100%);
    width: clamp(4rem, calc(15vw + 15px), 78px);
    height: clamp(4rem, calc(15vw + 15px), 78px);
    margin: 0 auto 12px;
    border-radius: 50%;
    text-align: center;
    position: relative;
  }
  img {
    width: clamp(4rem, calc(15vw + 7px), 70px);
    height: clamp(4rem, calc(15vw + 7px), 70px);
    border-radius: 50%;
    margin: 4px 0 0;
  }
  p {
    font: normal 12px/14.4px 'Lato-Bold', sans-serif;
    font-size: clamp(1rem, calc(3vw + 1.5px), 12px);
    margin: 0 0 2px;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 1;
    display: -webkit-box;
    padding: 0 8px;
    -webkit-box-orient: vertical;
  }
  span {
    font: normal 10px/10.54px $lato-bold;
    // font-size: clamp(0.5rem, calc(1.7vw + 1px), 8px);
    padding: 1.5px 6px;
    background: #b22254;
    border-radius: 6px;
    display: flex;
    margin: 8px auto 0 auto;
    justify-content: center;
    max-width: 110px;
    align-items: center;
    height: auto;
    text-transform: uppercase;
  }
}
#expert-users-list,
#expert-no-users {
  div:after {
    width: 24px;
    height: 24px;
    background: transparent url('/assets/img/expert-review-check-icon.svg') no-repeat center;
    position: absolute;
    right: -4px;
    bottom: -3px;
    content: '';
  }
}
#expert-no-users {
  padding: 60px 0;
  text-align: center;
  div {
    width: 80px;
    height: 80px;
    margin: 0 auto 35px;
    position: relative;
  }
  img {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    overflow: hidden;
  }
  p {
    font: normal 14px/22px $lato-bold;
    color: #8c8582;
  }
  div:after {
    right: -8px;
    bottom: -12px;
    width: 32px;
    height: 32px;
  }
}
#expert-users-nav {
  display: none;
}
// #expert-users-head {
//   h1 {
//     display: none;
//   }
// }

@media (min-width: 991px) {
  #expert-users-wrap {
    padding: 0 0 125px;
  }
  #expert-users-list {
    padding: 0 18px 10px;
    background: #fff;
    border-radius: 4px;
    box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.18);
    margin: 0 auto;
    max-width: 1140px;
    li {
      width: calc((100% - 60px) / 5);
      margin: 18px 6px 6px;
    }
  }
  #expert-users-head {
    display: flex;
    flex-wrap: wrap;
    max-width: 1140px;
    margin: 0 auto 16px;
    padding: 16px 0 24px 16px;
    background: #fff;
    box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.18);
    border-radius: 4px;
    h1 {
      font: 16px/22px $lato-bold;
      color: #231f20;
      margin: 0 0 24px;
      width: 100%;
    }
  }
  #expert-users-categories {
    order: 2;
    max-width: calc(100% - 366px);
    padding: 4px 0;
    position: relative;
    overflow: visible;
    li:first-child {
      margin: 0;
    }
    .swiper-slide {
      width: auto;
      margin: 0;
    }
    .button-prev,
    .button-next {
      position: absolute;
      left: 0;
      top: 0;
      width: 60px;
      height: 100%;
      background-image: -moz-linear-gradient(to right, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0));
      background-image: -ms-linear-gradient(to right, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0));
      background-image: -webkit-gradient(linear, 0 0, 100% 0, from(rgba(255, 255, 255, 1)), to(rgba(255, 255, 255, 0)));
      background-image: -webkit-linear-gradient(to right, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0));
      background-image: -o-linear-gradient(to right, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0));
      background-image: linear-gradient(to right, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0));
      background-repeat: repeat-x;
      filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='rgba(255, 255, 255, 1)', endColorstr='rgba(255, 255, 255, 0)', GradientType=1);
      z-index: 2;
      &:before {
        content: '';
        width: 36px;
        height: 36px;
        border-radius: 50%;
        background: #fff url('/assets/img/expert-review/icon-nav-arrow.svg') no-repeat center;
        box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.2);
        position: absolute;
        top: 2px;
        left: 14px;
        z-index: 3;
      }
    }
    .button-next {
      left: auto;
      right: 0;
      transform: scale(-1, 1);
    }
    .swiper-button-disabled {
      display: none;
    }
    &:after {
      display: none;
    }
    .dummy {
      width: 8px;
      height: 8px;
    }
  }
  #expert-users-search {
    order: 1;
    margin: 0 16px 0 0;
    width: 350px;
  }
  #expert-users-nav {
    display: block;
    max-width: 1140px;
    margin: 0 auto;
    padding: 24px 0 16px;
    a {
      color: #b32656;
      font: normal 14px/22px $lato-bold;
      display: flex;
      align-items: center;
    }
    a:before {
      content: '';
      width: 12px;
      height: 12px;
      background: transparent url('/assets/img/expert-review/left-arrow-red.svg') no-repeat center;
      margin: 0 10px 0 0;
    }
  }
  #expert-users-infinite-loading {
    margin-top: 8px;
  }
}
</style>
